<!--网站首页-->
<template>
  <div>
    <!--导航图-->
    <el-row>
      <el-col :span='24'>
        <div>
          <el-carousel class='carousel_class'>
            <el-carousel-item v-for='item in carouselList' :key='item.id'>
              <div class='div_image' @click='jump(item)'>
                <el-image class='image-slot'
                          :fit='fit'
                          v-if='item.imageUrl != null'
                          :src='item.imageUrl'
                />
                <h3>{{ item.name }}</h3>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>

    <!--客户案例-->
    <div class='title'>
      <div class='animate__animated animate__fadeInUp animate__slower'>
        <h1>客户案例</h1>
        <p>Customer Case</p>
      </div>
    </div>
    <el-row>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='16'>
        <div style='width:98%; height:32px; margin-bottom: 8px'>
          <el-button size='mini' type='info' plain style='float: right' @click='moreCase'>更多案例</el-button>
        </div>
        <div class='grid_content'>
          <div class='animate__animated animate__fadeInUp animate__slower'>
            <ul class='case'>
              <li class="homeImageList" v-for='item in homeCaseDataList' :key='item.id'>
                <vue-hover-mask @click='customerType(item)' style='height: 240px;width: 100%'>
                  <el-image class='smallNew'
                            :src='item.homeImageUrl'
                  />
                  <template v-slot:action>
                    <i class='iconfont icon-bianji-copy'>{{ item.profile }}</i>
                  </template>
                </vue-hover-mask>
              </li>
            </ul>
          </div>
          <ul class='serviceData'>
            <li>
              <div class='animate__animated animate__fadeInLeft animate__slower'>
                <div class='contentArea'>
                  <div class='dataText'>
                    <span class='dataFont'>{{ tableData.numberTrainees }}人+</span>
                    <span class='text'>在埃文接受培训</span>
                  </div>
                  <div class='imgs'>
                    <img src='../../assets/images/mainBusiness/train.png'>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class='animate__animated animate__fadeIn animate__slower'>
                <div class='contentArea'>
                  <div class='dataText'>
                    <span class='dataFont'>{{ tableData.numberCooperation }}+</span>
                    <span class='text'>政企服务项目</span>
                  </div>
                  <div class='imgs'>
                    <img src='../../assets/images/mainBusiness/cooperation.png'>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class='animate__animated animate__fadeInRight animate__slower'>
                <div class='contentArea'>
                  <div class='dataText'>
                    <span class='dataFont'>{{ tableData.serviceAmount }}+</span>
                    <span class='text'>服务金额</span>
                  </div>
                  <div class='imgs'>
                    <img src='../../assets/images/mainBusiness/money.png'>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>

    <!--主营业务-->
    <div class='title' :class="{beforeX:true,xEnter:businessShow}" ref="businessRef">
      <!-- <div class='animate__animated animate__slideInRight animate__slower'> -->
        <h1>主营业务</h1>
        <p>Business</p>
      <!-- </div> -->
    </div>
    <el-row :class="{beforeX:true,xEnter:businessShowContent}">
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='16'>
        <div class='animate__animated animate__slideInRight animate__slower'>
          <div class='grid_content'>
            <ul class='businessTitle'>
              <li class='businessContent' v-for='item in businessListData' :key='item.id'>
                <div class='titleBorder'>
                  <h1 class='chineseTitle'>{{ item.typeName }}</h1>
                  <p class='englishTitle'>{{ item.typeEnglishName }}</p>
                </div>
                <ul class='businessDetails'>
                  <div class='catalogue'>
                    <li v-for='item1 in item.children' :key='item1.id'>
                      <img src='../../assets/images/homePage/dot.png'>
                      <a @click='typeList(item.typeName,item1.id)'>{{ item1.name }}</a>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>

    <!--新闻中心-->
    <!-- <div class='animate__animated animate__fadeInDown animate__slower'> -->
      <div class='journalism_title' :class="{beforeX:true,xEnter:newCenterShow}" ref="newCenterRef">
        <h1>新闻与资讯</h1>
        <p>News & Views</p>
      </div>
    <!-- </div> -->
    <el-row  :class="{beforeX:true,xEnter:newCenterShow}">
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='8'>
        <div class='animate__animated animate__fadeInLeft animate__slower'>
          <div class='grid_content'>
            <h2 class='newsHeadline'>公司新闻</h2>
            <ul style='min-height: 180px;margin-bottom: 5px'>
              <li class='newsList' v-for='item in homeCompanyNewsListData' :key='item.id' @click='doctor(item)'>
                <span class='sortBorders'>{{ item.rowNum }}</span>
                <span class='newsContent'>{{ item.title }}</span>
              </li>
            </ul>
            <el-row style='float: right;margin-right: 50px'>
              <el-button size='mini' type='info' plain @click='journalism(1)'>更多新闻</el-button>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span='8'>
        <div class='animate__animated animate__fadeInLeft animate__slower'>
          <div class='grid_content'>
            <div class='grid_content'>
              <h2 class='newsHeadline'>行业资讯</h2>
              <ul style='min-height: 180px;margin-bottom: 5px'>
                <li class='newsList' v-for='item in homeIndustryNewsListData' :key='item.id' @click='doctor(item)'>
                  <span class='sortBorders'>{{ item.rowNum }}</span>
                  <span class='newsContent'>{{ item.title }}</span>
                </li>
              </ul>
              <el-row style='float: right;margin-right: 50px'>
                <el-button size='mini' type='info' plain @click='journalism(2)'>更多资讯</el-button>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>

    <!--博士观点-->
    <!-- <div class='animate__animated animate__fadeInDown animate__slower'> -->
      <div class='title' :class="{beforeX:true,xEnter:viewPointShow}" ref="viewPointRef">
        <h1>埃文博士观点</h1>
      </div>
    <!-- </div> -->
    <el-row :class="{beforeX:true,xEnter:viewPointShow}">
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='16'>
        <div class='animate__animated animate__slideInRight animate__slower'>
          <div class='grid_content'>
          <ul style='min-height: 240px'>
            <li class='doctoralViewpoint' v-for='item in homeDoctorListData' :key='item.id' @click='doctor(item)'>
              <div class='doctoralViewpointWidth'>
                <div class='titleImg'>
                  <el-image class='doctorImage'
                            :src='item.imageUrl'
                  />
                </div>
                <div class='titleText'>
                  <p class='articleTitle'>{{ item.title }}</p>
                  <p>{{ item.author }}</p>
                  <p> {{ item.releaseTime }}</p>
                </div>
              </div>
            </li>
          </ul>
          <el-row style='margin: 20px auto ;display: block;width: 80px'>
            <el-button size='mini' type='info' plain @click='journalism(3)'>更多观点</el-button>
          </el-row>
        </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>

    <!--合作伙伴 animate__animated animate__fadeInDown animate__slower-->
    <!-- <div :class="isShowAnimation ? 'animate__animated animate__fadeInDown animate__slower' :''"> -->
      <div class='cooperation_title' :class="{beforeX:true,xEnter:cooperateShow}" ref="cooperateRef">
        <h1>合作伙伴</h1>
        <p>cooperative partner</p>
      </div>
    <!-- </div> -->
    <el-row :class="{beforeX:true,xEnter:cooperateShow}">
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='16'>
        <div class='animate__animated animate__fadeInUp animate__slower animate__delay-1s'>
          <div class='grid_content'>
          <ul class='cooperativePartner'>
            <li v-for='item in cooperativePartnerListData' :key='item.id'>
              <div class='cooperativePartnerImg' @click='jumpPartner(item)'>
                <el-image class='small'
                          :src='item.imageUrl'
                />
              </div>
            </li>
          </ul>
        </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>

    <!--影像资料-->
    <!-- <div class='animate__animated animate__fadeInDown animate__slower'> -->
      <div class='title'  :class="{beforeX:true,xEnter:videoShow}" ref="videoRef">
        <h1>影像资料</h1>
        <p>video</p>
      </div>
    <!-- </div> -->
    <el-row :class="{beforeX:true,xEnter:videoShow}">
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='16'>
        <!-- <div class='animate__animated animate__slideInRight animate__slower'> -->
         <div class='grid_content'>
          <ul class='video'>
            <li>
              <div class='videoPlayback'>
                <VideoPlay
                  v-show='true'
                  :videoUrl='videoUrl'
                  :videoCover='videoCover'
                  :autoplay='false'
                  :controls='true'
                  :loop='false'
                  :muted='false'
                  preload='auto'
                  :showPlay='false'
                  :playWidth='96'
                  zoom='cotain'
                />
              </div>
            </li>
            <li>
              <div class='videoTitle'>
                <p>
                  <img src='../../assets/images/homePage/upArrow.png' @click='previousPage'>
                </p>
                <ul>
                  <li v-for='item in homeVideoListData' :key='item.id' @click='videoOnClick(item)'>
                    {{ item.name }}
                  </li>
                </ul>
                <p>
                  <img src='../../assets/images/homePage/downArrow.png' @click='nextPage'>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <!-- </div> -->
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VueHoverMask from 'vue-hover-mask'
import VideoPlay from '../../components/VideoPlay'

import {
  cooperativePartnerList,
  homeCaseList,
  homeCompanyNewsList,
  homeDoctorList, homeIndustryNewsList, selectCarouselPicture,
  selectConfig, selectVideo,
  webBusinessList
} from '../../api/auth'

export default {
  created () {
    this.webConfig()
    this.homeCaseList()
    this.webBusinessList()
    this.cooperativePartnerList()
    this.homeDoctorList()
    this.homeCompanyNewsList()
    this.homeIndustryNewsList()
    this.selectVideo(1)
    this.selectCarouselPicture(1)
  },
  data () {
    return {
      title: '客服',
      isShowAnimation: false,
      businessShow: false,
      businessShowContent: false,
      newCenterShow: false,
      viewPointShow: false,
      cooperateShow: false,
      videoShow: false,
      // 表单校验
      productCategoryRule: {
        name: [
          { required: true, message: '问题名称不能为空', trigger: 'blur' }
        ],
        answer: [
          { required: true, message: '问题答复不能为空', trigger: 'blur' }
        ]
      },
      // 类别表单
      productCategoryFrom: {
        id: null,
        name: '',
        answer: ''
      },
      // 视频链接支持https或require本地地址
      videoUrl: '',
      //  videoUrl: require('../../assets/11111.mp4'),
      // 视频封面支持https或require本地地址
      videoCover: require('../../assets/images/bmp.jpg'),
      // 是否显示弹出层
      open: false,
      fit: 'scale-down', // 想要什么属性就在这个位置设置什么属性
      carouselList: [],
      carouselParams: {
        type: 1
      },
      dataList: [],
      homeCaseDataList: [],
      queryParams: {},
      queryVideoParams: {
        pageNum: 1,
        pageSize: 6
      },
      businessListData: [],
      homeDoctorListData: [],
      cooperativePartnerListData: [],
      homeCompanyNewsListData: [],
      homeIndustryNewsListData: [],
      homeVideoListData: [],
      // 总条数
      total: 0,
      // 总页数
      pages: 0,
      currentPage: 1,
      tableData: {
        numberTrainees: '',
        numberCooperation: '',
        serviceAmount: ''
      }
    }
  },
  components: {
    VueHoverMask,
    // eslint-disable-next-line vue/no-unused-components
    VideoPlay
  },
  mounted () {
    this.byEvents()
    window.addEventListener('scroll', this.scrollHandle, true)// 监听 监听元素是否进入/移出可视区域
  },
  inject: ['say', 'sayNew'],
  methods: {
    scrollHandle () {
      const offset = this.$el.getBoundingClientRect()
      const offsetTop = offset.top
      const offsetBottom = offset.bottom
      this.currentScroll = window.pageYOffset // 表示当前滚动的位置
      // const offsetHeight = offset.height;
      // 进入可视区域
      // console.log(offsetTop,offsetBottom)
      if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
        console.log('进入可视区域' + window.innerHeight)
        this.isShowAnimation = true
      } else {
        this.isShowAnimation = false
        console.log('移出可视区域')
      }
      if (this.currentScroll >= this.$refs.businessRef.offsetTop - 600) {
        // 当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.businessShow = true
        this.businessShowContent = true
      }

      if (this.currentScroll >= this.$refs.newCenterRef.offsetTop - 600) {
        // 当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.newCenterShow = true
      }
      if (this.currentScroll >= this.$refs.viewPointRef.offsetTop - 600) {
        // 当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.viewPointShow = true
      }
      if (this.currentScroll >= this.$refs.cooperateRef.offsetTop - 600) {
        // 当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.cooperateShow = true
      }

      if (this.currentScroll >= this.$refs.videoRef.offsetTop - 600) {
        // 当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.videoShow = true
      }
    },
    nextPage () {
      if (this.currentPage < this.pages) {
        this.currentPage++
        this.selectVideo(this.currentPage)
      }
    },
    previousPage () {
      if (this.currentPage > 1) {
        this.currentPage--
        this.selectVideo(this.currentPage)
      }
    },
    /** 查询视频 */
    selectVideo (raw) {
      let that = this
      this.queryVideoParams.pageNum = raw
      selectVideo(this.queryVideoParams).then(res => {
        that.homeVideoListData = res.records
        this.total = res.total
        this.pages = res.pages
        if (that.homeVideoListData && that.homeVideoListData.length > 0) {
          that.videoUrl = that.homeVideoListData[0].videoUrl
        } else {
        }
      })
    },
    videoOnClick (raw) {
      this.videoUrl = raw.videoUrl
    },
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    jumpPartner (raw) {
      //  alert(raw.url)
      //  window.open('https://www.baidu.com/', '_blank')
    },
    /** 公司新闻滚动图  */
    selectCarouselPicture (raw) {
      let that = this
      that.carouselParams.type = raw
      selectCarouselPicture(that.carouselParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.carouselList = res
      })
    },
    /** 首页公司新闻中心 */
    homeCompanyNewsList () {
      let that = this
      homeCompanyNewsList(this.queryParams).then(res => {
        that.homeCompanyNewsListData = res
      })
    },
    /** 首页行业新闻中心 */
    homeIndustryNewsList () {
      let that = this
      homeIndustryNewsList(this.queryParams).then(res => {
        that.homeIndustryNewsListData = res
      })
    },
    /** 合作伙伴 */
    cooperativePartnerList () {
      let that = this
      cooperativePartnerList(this.queryParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.cooperativePartnerListData = res
      })
    },
    /** 首页查询埃文博士观点 */
    homeDoctorList () {
      let that = this
      homeDoctorList(this.queryParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        that.homeDoctorListData = res
      })
    },

    /** 首页客户案例查询 */
    // eslint-disable-next-line vue/no-dupe-keys
    homeCaseList () {
      let that = this
      homeCaseList(that.queryParams).then(res => {
        res.forEach((value, index) => {
          value.homeImageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })

        that.homeCaseDataList = res
      })
    },
    /** 查询主营业务 */
    webBusinessList () {
      let that = this
      webBusinessList(this.queryParams).then(res => {
        that.businessListData = res
      })
    },
    /** 查询网站配置 */
    webConfig () {
      let that = this
      selectConfig(that.queryParams).then(res => {
        that.tableData.numberTrainees = res.numberTrainees
        that.tableData.numberCooperation = res.numberCooperation
        that.tableData.serviceAmount = res.serviceAmount
      })
    },
    byEvents () {
      this.dataList = [{
        img: 'one',
        title: '标题'
      }, {
        img: 'two',
        title: '标题'
      }, {
        img: 'three',
        title: '标题'
      }]
    },
    typeList (typeName, id) {
      this.sayNew(typeName, id)
    },
    doctor (raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
          type: 2
        }
      })
    },
    journalism (raw) {
      if (raw === 1) {
        this.say('更多新闻')
      } else if (raw === 2) {
        this.say('更多资讯')
      } else if (raw === 3) {
        this.say('更多观点')
      }
    },
    moreCase () {
      this.say('更多案例')
    },
    customerType (raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
          type: 1
        }
      })
    }
  }
}
</script>
<style>
.homeImageList .vue-hover-mask_action,.homeImageList img {

  transition: 0.5s ease-in-out;
}
.homeImageList:hover .vue-hover-mask_action {
  transform: scale(1.1);
}
.homeImageList:hover img {
  transform: scale(1.1);
}
</style>
<style lang='less' scoped>
.xEnter{
  transform: translateY(0) !important;
  opacity: 1!important;
  transition: all 0.8s ease;
}
.beforeX{
  transform: translateY(50px);
  opacity: 0;
}
.title {
  height: 190px;
  text-align: center;
  padding-top: 50px;

  h1 {
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 1px;
    font-family: 'fontName';
    color: #606060;
  }

  p {
    font-size: 24px;
    color: #6c6c6c;
  }
}

.journalism_title {
  height: 130px;
  text-align: center;
  padding-top: 50px;
  width: 65%;
  display: block;
  margin: 50px auto 20px;
  background-image: url("../../assets/images/homePage/title1.png");

  h1 {
    margin-top: -30px;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 1px;
    font-family: 'fontName';
    color: #606060;
  }

  p {
    font-size: 24px;
    color: #6c6c6c;
  }
}

.cooperation_title {
  height: 130px;
  text-align: center;
  padding-top: 50px;
  width: 65%;
  display: block;
  margin: 15px auto;
  background-image: url("../../assets/images/homePage/title1.png");

  h1 {
    margin-top: -20px;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 1px;
    font-family: 'fontName';
    color: #606060;
  }

  p {
    font-size: 24px;
    color: #6c6c6c;
  }
}

.carousel_class {
  height: 440px;
  margin: 0;
  padding: 0;
 ::v-deep .el-carousel__container{
    height:440px !important;
    .image-slot {
      width: 100%;
      height: 440px;
      margin-bottom: 40px;
    }
  }
}

.grid_content {
  min-height: 100px;
  //客户案例
  .case {
    height: 240px;
    margin-bottom: 20px;
    ::v-deep .vue-hover-mask_action {
      height: 240px;
    }
    li {
      display: block;
      float: left;
      width:33.33%;
      height: 240px;
      padding:0 10px;
      margin-bottom: 18px;

      .smallNew {
        width:100%;
        height:100%;
      }

      i {
        display: block;
        width: 90%;
        font-size: 16px;
        font-style: normal;
        font-family: "MicrosoftYaHei";
        text-align: center;
        line-height: 25px;
        padding: 15px;
        text-shadow: 2px 2px 6px #000;
        margin: 90px auto 0;
      }
    }
  }

  .serviceData {
    margin-top: 50px;

    li {
      margin-top: 20px;
      display: block;
      float: left;
      width: 33.33%;

      .contentArea {
        padding: 5px 10px;
        display: block;
        margin: 0 auto;
        width: 90%;
        height: 52px;
        border: 1px solid #999;
        .dataText{
          float: left;
          width: 85%;
          .dataFont {
            font-size: 26px;
            font-weight: bold;
            color: #666;
          }
          .text {
            font-size: 18px;
            font-family: "MicrosoftYaHei";
            color: #999;
          }
        }
        .imgs{
          float: right;
          width: 15%;
          img {
            height: 36px;
            width: 36px;
            display: block;
            float: right;
          }
        }
      }
    }
  }

  //主营业务
  .businessTitle {
    .businessContent {
      display: block;
      float: left;
      width: 33.33%;

      .titleBorder {
        padding: 11px 0 0;
        text-align: center;
        width: 90%;
        margin: 0 auto;
        border: 1px solid #72b456;
        border-radius: 20px;
        height: 90px;

        .chineseTitle {
          //font-weight: bold;
          font-size: 26px;
          color: #606060;
        }
      }
    }
  }

  .businessDetails {
    border: 1px solid #72b456;
    border-radius: 20px;
    width: 90%;
    margin: 20px auto 0;

    .catalogue {
      height: 340px;
      padding: 15px 0;
      border-radius: 20px;
      font-size: 14px;
      line-height: 30px;
      font-family: "MicrosoftYaHei";

      li {
        width: 100%;
        padding: 0 15px;
        overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap; /*文本不换行*/

        img {
          float: left;
        }

        a {
          color: #6c6c6c;
          font-size: 16px;
        }

        a:hover {
          color: #019301;
          //font-weight: bold;
        }
      }
    }
  }

  //新闻中心
  .newsHeadline {
    width: 93%;
    margin: 10px auto;
    display: block;
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .newsList {
    min-height: 30px;
    width: 93%;
    margin: 0 auto;

    .sortBorders {
      display: block;
      float: left;
      text-align: center;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      width: 8%;
      height: 24px;
      border: 1px solid #72b456;
      border-radius: 5px;
    }

    .newsContent {
      display: block;
      float: left;
      font-size: 14px;
      padding-left: 5px;
      font-family: "MicrosoftYaHei";
      width: 82%;
      cursor: pointer;
      overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
      text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
      white-space: nowrap; /*文本不换行*/
    }
  }

  //埃文博士观点
  .doctoralViewpoint {
    display: block;
    height: 70px;
    width: 50%;
    float: left;
    margin-bottom: 10px;

    .doctoralViewpointWidth {
      display: block;
      width: 93%;
      height: 70px;
      margin: 0 auto;

      .titleImg {
        display: block;
        float: left;
        width: 20%;

        .doctorImage {
          border: none;
          min-width: 100%;
          height: 70px;
          cursor: pointer;
        }
      }

      .titleText {
        display: block;
        float: left;
        padding-left: 10px;
        width: 80%;

        .articleTitle {
          display: block;
          line-height: 25px;
          font-size: 14px;
          font-weight: bold;
          font-family: "MicrosoftYaHei";
          cursor: pointer;
          overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
          text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
          white-space: nowrap; /*文本不换行*/
        }

        p {
          font-family: "MicrosoftYaHei";
          line-height: 25px;
        }
      }
    }
  }

  //合作伙伴
  .cooperativePartner {
    li {
      display: block;
      float: left;
      width: 25%;

      .cooperativePartnerImg {
        width: 90%;
        display: block;
        margin: 0px auto 20px;
      }

      img {
        width: 100%;
        height: 70px;
      }
    }
  }

  //影视资料
  .video {
    li {
      width: 50%;
      float: left;
      height: 300px;

      .videoTitle {
        height: 300px;
        p{
          height: 30px;
          width: 100%;
          background-image: url("../../assets/images/homePage/edge.png");
          background-repeat: no-repeat;

          img {
            display: block;
            margin: 0 auto;
            cursor: pointer;
          }
        }

        ul {
          height: 240px;

          li {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 18px;
            font-family: SourceHanSansSC;
            overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
            text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
            white-space: nowrap; /*文本不换行*/
            cursor: pointer;
          }
        }
      }
    }
  }
}

.pic_item_1:hover {
  cursor: pointer;
}

.small {
  width: 100%;
  height: 70px;
  position: relative;

}

.smallRoll {
  width: 100%;
  height: 300px;
  position: relative;

}

.smallNew:hover {
  width: 100%;
  height: 240px;
  transform: scale(1.1); //图片按照比例，整体放大了1.2倍
  // 当鼠标经过是图片放大的倍数为1.2倍
}

::v-deep .vue-hover-mask_action {
  background: linear-gradient(-90deg, rgba(5, 201, 127, 0.6), rgba(6, 172, 250, 0.7));
  border-radius: 10px;
}

//视频播放设置
::v-deep .m-video {
  width: 96% !important;
  height: 300px !important;
}

::v-deep video {
  width: 100%;
  height: 300px;
}
</style>
